'use client'

import React, { useState } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import CampsTable from './CampsTable'

interface CampsComparisonDashboardProps {
  camps: any[]
  categories: any[]
  selectedYear: string
  selectedCategory: string
}

const CampsComparisonDashboard: React.FC<CampsComparisonDashboardProps> = ({
  camps,
  categories,
  selectedYear,
  selectedCategory,
}) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  // Generate year options (current year ± 3 years)
  const currentYear = new Date().getFullYear()
  const yearOptions = Array.from({ length: 7 }, (_, i) => currentYear - 3 + i)

  const handleCategoryChange = (categoryId: string) => {
    const params = new URLSearchParams(searchParams?.toString())
    if (categoryId === 'all') {
      params.delete('category')
    } else {
      params.set('category', categoryId)
    }
    router.push(`/admin/camps-comparison?${params.toString()}`)
  }

  const handleYearChange = (year: string) => {
    const params = new URLSearchParams(searchParams?.toString())
    if (year === 'all') {
      params.delete('year')
    } else {
      params.set('year', year)
    }
    router.push(`/admin/camps-comparison?${params.toString()}`)
  }

  return (
    <div className="space-y-6">
      {/* Filters */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex items-center gap-6">
          {/* Category Filter */}
          <div className="flex items-center gap-3">
            <label className="text-sm font-medium text-gray-700">Kategorie:</label>
            <select
              value={selectedCategory}
              onChange={(e) => handleCategoryChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="all">Alle Kategorien</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          {/* Year Filter */}
          <div className="flex items-center gap-3">
            <label className="text-sm font-medium text-gray-700">Jahr:</label>
            <select
              value={selectedYear}
              onChange={(e) => handleYearChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="all">Alle Jahre</option>
              {yearOptions.map((year) => (
                <option key={year} value={year.toString()}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          {/* Results count */}
          <div className="text-sm text-gray-600 ml-auto">{camps.length} Camp(s) gefunden</div>
        </div>
      </div>

      {/* Camps Table */}
      <CampsTable camps={camps} />
    </div>
  )
}

export default CampsComparisonDashboard
